import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";

const SearchBox = ({ onSubmit, label }) => {
    const [value, setValue] = useState({ query: "" });
    const onKeyPress = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            onSubmit(value);
        }
    };
    useEffect(() => {
        if (value.query === "") onSubmit({ query: "" });
    }, [value]);
    return (
        <Box
            component="form"
            sx={{
                "& > :not(style)": { m: 1, width: "40ch" },
            }}
            noValidate
            autoComplete="off"
        >
            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    onSubmit(value);
                }}
            >
                <TextField
                    id="outlined-basic"
                    label={label ? label : "Recherche"}
                    variant="outlined"
                    value={value.query}
                    fullWidth
                    onChange={(e) => setValue({ query: e.currentTarget.value })}
                    onKeyPress={(e) => onKeyPress(e)}
                />
            </form>
        </Box>
    );
};

export default SearchBox;
